document.addEventListener('DOMContentLoaded', function () {
  const currentProductHandle = "{{ product.handle }}"; 
  let variants = document.querySelectorAll('.pancake-flavours-wrapper .product-grouping li');
  
  variants.forEach(variant => {
    let productLink = variant.querySelector('a').getAttribute('href');
    
    if (productLink.includes(currentProductHandle)) {
      variant.classList.add('selected');
    }

    variant.addEventListener('click', function () {
      variants.forEach(v => v.classList.remove('selected'));
      this.classList.add('selected');
    });
  });
});
